var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelatedArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.5H19.5V20V4V3.5H19H5H4.5V4V20V20.5H5H19ZM20 21.5H4C3.72386 21.5 3.5 21.2762 3.5 21V3C3.5 2.72386 3.72386 2.5 4 2.5H20C20.2762 2.5 20.5 2.72386 20.5 3V21C20.5 21.2762 20.2762 21.5 20 21.5ZM7.5 6.5H10.5V9.5H7.5V6.5ZM7.5 12.5H16.5V13.5H7.5V12.5ZM7.5 16.5H16.5V17.5H7.5V16.5ZM13.5 7.5H16.5V8.5H13.5V7.5Z",
    fill: "black",
    stroke: "#220046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedArticle);
export default __webpack_public_path__ + "static/media/relatedArticle.70d5f283bc6d78d6e01eeacabab017f4.svg";
export { ForwardRef as ReactComponent };